import CustomZObject from './CustomZObject.js';

export default class SynthControl extends CustomZObject {
    constructor(zobject) {
        super(zobject);

        this.newInlet("ADSR Levels", (msg) => this.onADSRLevels(msg[0]));
        this.newOutlet("ADSR levels");

        this.newInlet("Oscillator Levels", (msg) => this.onOscillatorLevels(msg[0]));
        this.newOutlet("Oscillator levels");
    }

    sendOscillatorLevels() {
        if (!this.synth) {
            return;
        }
        let levels = this.synth.oscillatorNodes.map(
            x => x.oscillatorLevelParameter.get(true));
        this.sendMessage("Oscillator levels", levels);
    }
    
    sendADSRLevels() {
        if (!this.synth) {
            return;
        }
        let amp = this.synth.ampEnvelope;
        this.sendMessage("ADSR levels",
                         [this.attack, this.decay, this.sustain, this.release]);
    }

    get amp() {
        return this.synth.ampEnvelope;
    }

    set attack(x) {
        if (!this.synth) {
            return;
        }
        let val = unscaleValue(x, this.amp.attackParameter.min, this.amp.attackParameter.max);
            
        if (val !== this.amp.attack) {
            this.amp.attackParameter.set(
                val,
                false);
        }
    }

    get attack() {
        if (!this.synth) {
            return;
        }
        return scaleValue(this.amp.attack, this.amp.attackParameter.min, this.amp.attackParameter.max);
    }

    set decay(x) {
        if (!this.synth) {
            return;
        }
        let decay = unscaleValue(x, this.amp.decayParameter.min, this.amp.decayParameter.max);
        if (decay !== this.amp.decay) {
            this.amp.decayParameter.set(
                decay,
                false);
        }
    }

    get decay() {
        if (!this.synth) {
            return;
        }
        return scaleValue(this.amp.decay, this.amp.decayParameter.min, this.amp.decayParameter.max);
    }

    set sustain(x) {
        if (!this.synth) {
            return;
        }
        if (x !== this.amp.sustain) {
            this.amp.sustainParameter.set(
                x,
                false);
        }
    }

    get sustain() {
        if (!this.synth) {
            return;
        }
        return this.amp.sustain;
    }

    set release(x) {
        if (!this.synth) {
            return;
        }
        let release = unscaleValue(x, this.amp.releaseParameter.min, this.amp.releaseParameter.max);
        if (release !== this.amp.release) {
            this.amp.releaseParameter.set(
                release,
                false);
        }
    }

    get release() {
        if (!this.synth) {
            return;
        }
        return scaleValue(this.amp.release, this.amp.releaseParameter.min, this.amp.releaseParameter.max);
    }

    onOscillatorLevels(levels) {
        if (!this.synth) {
            return;
        }

        if (Array.isArray(levels)) {
            this.synth.oscillatorNodes.forEach(
                (x,i) => {
                    let level = levels[i%levels.length];
                    if (level !== x.oscillatorLevelParameter.get(true)) {
                        x.oscillatorLevelParameter.set(level, false);
                    }
                });
        } else {
        }
    }

    onADSRLevels(levels) {
        if (!this.synth) {
            return;
        }

        if (Array.isArray(levels)) {
            if (!isNaN(levels[0])) {
                this.attack = levels[0];
            }
            if (!isNaN(levels[1])) {
                this.decay = levels[1];
            }
            if (!isNaN(levels[2])) {
                this.sustain= levels[2];
            }
            if (!isNaN(levels[3])) {
                this.release = levels[3];
            }
        } else {
        }
    }

    linkSynth(synth) {
        this.synth = synth;
        this.synth.controller = this;
    }

    getJson(isPreset) {
        return {
            ... super.getJson(isPreset),
            synthId: this.synth.id
        };
    }

    fromJson(json, isCopy) {
        super.fromJson(json, isCopy);

        // find the synth
        let subSequence = this.subSequence.getRootSubSequence();
        for (let track of subSequence.tracks) {
            if (track && track.instrument && track.instrument.id === json.synthId) {
                this.linkSynth(track.instrument);
            }
        }
    }
}


const unscaleValue = (value, min, max) => {
    value = Math.max(0, value);
    //Math.pow(value, 2);
    return value * (max-min);
}

const scaleValue = (value, min, max) => {
    value = Math.max(0, value);
    return Math.pow((value - min)/(max-min), 1);
};
